export default "__VITE_ASSET__BEOWY95R__ 300w, __VITE_ASSET__BoBO0Y72__ 500w, __VITE_ASSET__DMnxDcgA__ 800w";